import axios from 'axios'
import { getToken } from '@/utils/auth'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 10000
})

service.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => Promise.reject(error)
)

export function exportConvertCode(comboId) {
    return service({
        url: '/video/export/convertcombo/exportConvertCode',
        method: 'GET',
        params: { comboId },
        responseType: 'blob'
    })
}
